import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Input } from "@progress/kendo-react-inputs";
import { CustomDropdown } from "../shared/customDropdown";
import { PreauthorizationInvestigations } from './preauthorizationInvestigations';
import { PreauthorizationDiagnostics } from './preauthorizationDiagnostics';
import { PreauthorizationForms } from './preauthorizationForms';
import { PreauthorizationFiles } from './preauthorizationFiles';
import { preauthorizationService } from "../../services/api/preauthorization.service";
import { partnerService } from "../../services/api/partner.service";
import { utils } from "../../services/helpers/utils";
import { alertService } from "../../services/helpers/alert.service";


export const Preauthorization = (props) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const navigate = useNavigate();

    const param = {
        pacient: searchParams.get("pacient"),
        contract: searchParams.get("contract"),
        id: searchParams.get("id"),
    };

    const [isModified, setIsModified] = useState(false);
    const [preautorizare, setPreautorizare] = useState({});

    // Listele de investigatii, diagnostice si fisiere
    const [investigatii, setInvestigatii] = useState([]);
    const [diagnostice, setDiagnostice] = useState([]);
    const [formulare, setFormulare] = useState([]);
    const [fisiere, setFisiere] = useState([]);
    const [nrFisiere, setNrFisiere] = useState(0);
    const [doRender, setDoRender] = useState(false);

    const partener = sessionStorage.getItem("idPartener");

    const [refresh, setRefresh] = useState(false);

    useEffect(() => {
        
        if (param.id) {
            preauthorizationService.getPreauthorization({ preauthorizationId: param.id })
                .then(response => {
                    if (response) {
                        setPreautorizare(response);
                        setDoRender(true);
                    }

                });
        }
        else if (param.pacient && param.contract) {
            preauthorizationService.getHeader({
                pacient: param.pacient,
                subscription: param.contract,
                partener: partener,
            })
                .then(response => {
                    if (response) {
                        setPreautorizare(response);
                        setDoRender(true);
                    }

                });
        }
        

    }, []);

   
    const handleChange = (event) => {

        const { name, value } = event.target;

        // daca value e obiect 
        if (typeof value === "object") {
            // Daca are id e dropdown
            if (value && value.hasOwnProperty("id")) {
                setPreautorizare((prevParams) => ({ ...prevParams, [name]: value.id }));
            }
            // Daca nu are id e data
            else {
                setPreautorizare((prevParams) => ({ ...prevParams, [name]: value }));
            }
        }
        else {
            setPreautorizare((prevParams) => ({ ...prevParams, [name]: value }));
        }

        setIsModified(true);
    }


    const handleCancel = () => {

        if (preautorizare.statusFinalizare == 1) {
            navigate(-1);
            return;
        }

        if (isModified) {
            alertService.confirm("Atentie", "Datele au fost modificate. Renuntati la modificari?",
                () => { navigate(-1); },
                () => { return });
        }
        else {
            navigate(-1);
        }
    }

    const verify = () => {

        // Verificari liste
        if (investigatii.length === 0) {
            alertService.error("Adaugati cel putin o investigatie!");
            return false;
        }

        if (investigatii.length > 0) {
            for (var i = 0; i < investigatii.length; i++) {
                if (!investigatii[i].idInvestigatie) {
                    alertService.error("Completati investigatia de la randul " + (i + 1) + "!");
                    return false;
                }
            }
        }

        if (diagnostice.length === 0) {
            alertService.error("Adaugati cel putin un diagnostic!");
            return false;
        }


        if (diagnostice.length > 0) {
            for (var i = 0; i < diagnostice.length; i++) {
                if (!diagnostice[i].idDiagnostic) {
                    alertService.error("Completati diagnosticul de la randul " + (i + 1) + "!");
                    return false;
                }
            };
        }

        // Verificari campuri preautorizare
        if (!preautorizare.data) {
            alertService.error("Selectati data!");
            return false;
        }

        if (!preautorizare.idMedic) {
            alertService.error("Completati medicul solicitant!");
            return false;
        }

        return true;

    }

    const handleSave = (paramPreautorizare) => {

        const savePreautorizare = paramPreautorizare.hasOwnProperty("id") ? paramPreautorizare : preautorizare;

        if (!verify()) return false;
        const isFinalizata = (savePreautorizare.statusFinalizare == 1);

        const formData = new FormData();
        utils.convertObject(formData, savePreautorizare, 'preautorizare');
        utils.convertArray(formData, investigatii, 'investigatii');
        utils.convertArray(formData, diagnostice, 'diagnostice');
        utils.convertArray(formData, formulare, 'formulare');
        convertFiles(formData, fisiere, 'fisiere');

        preauthorizationService.savePreauthorization(formData).then(response => {
            if (response) {
                if (!preautorizare.id && response.id) {
                    const updatePreautorizare = { ...preautorizare, id: response.id };
                    setPreautorizare(updatePreautorizare);
                }
                setRefresh(!refresh);
                const message = (isFinalizata) ? "Preautorizarea a fost finalizata cu succes!" : "Preautorizarea a fost salvata cu succes!";
                alertService.success(message);
                setIsModified(false);
                return true;
            }
            else {
                return false
            }
        });

    }

    /* Finalizare */
    const handleCompletion = () => {
        if (!verify()) return ;

        if (preautorizare.statusFinalizare == 1) {
            return
        }
        const updatedPreautorizare = { ...preautorizare, statusFinalizare: 1 };
        setPreautorizare(updatedPreautorizare);
        handleSave(updatedPreautorizare);

    }

    const convertFiles = (formData, list, path) => {
        for (var i = 0; i < list.length; i++) {
            var file = {
                Id: list[i].id,
                IdPreautorizare: list[i].idPreautorizare,
                Description: list[i].descriere,
                File: list[i].fisier
            };
            utils.convertObject(formData, file, `${path}[${i}]`);
        }
    }

    return (
        <>
            <h2 className="pt20 pb10">Preautorizare consultatii</h2>
            <div className="formular">
                <fieldset>
                    <div className="clearfix">
                        <div className="fl">
                            <label className="pb5">Nume: </label>
                            <Input name="nume" value={preautorizare.nume} readOnly />

                            <label className="pt10 pb5">Prenume:</label>
                            <Input name="prenume" readOnly value={preautorizare.prenume } />

                            <label className="pt10 pb5">Cod:</label>
                            <Input name="cod_pacient" readOnly value={preautorizare.cod} />

                            <label className="pt10 pb5">CNP:</label>
                            <Input name="cnp" readOnly value={preautorizare.cnp} />

                            <label className="pt10 pb5">Telefon:</label>
                            <Input name="telefon" readOnly value={preautorizare.telefon} />

                            <label className="pt10 pb5">Tip abonament:</label>
                            <Input name="abonament" readOnly value={preautorizare.abonament} />

                            <label className="pt10 pb5">Data:</label>
                            <span name="data"> {utils.dateDisplay(preautorizare.data)}  {(preautorizare.ora ?  preautorizare?.ora.substring(0,5) : "") } </span>
                        </div>

                        <div className="fr">
                            <label className="pb5">Partener:</label>
                            <Input name="id_partener" readOnly value={preautorizare.partener} />
                            <label className="pt10 pb5">Medic solicitant: <span className="red">*</span></label>
                            <div className="clearfix">
                                <CustomDropdown className="fl"
                                    name="idMedic"
                                    request={partnerService.getInternalDoctors}
                                    initialValue={preautorizare.idMedic}
                                    requestParams={{ partener: (param.id ? preautorizare.idPartener : partener) }}
                                    doRender={doRender} 
                                    disabled={preautorizare.statusFinalizare == 1}
                                    onChangeEvent={handleChange}
                                    isSearcheable={true}
                                    filterable
                                />
                            </div>
                            <PreauthorizationInvestigations
                                id={param.id}
                                pacient={preautorizare.idPacient}
                                partener={ param.id ?  preautorizare.idPartener : partener}
                                abonament={preautorizare.idAbonament}
                                data={preautorizare.data}
                                finalizare={preautorizare.statusFinalizare}
                                setInvestigatii={setInvestigatii}
                                setIsModified={setIsModified}
                                refresh={refresh}
                            />
                        </div>
                    </div>
                </fieldset>
            </div>

            
            <PreauthorizationDiagnostics
                id={param.id}
                finalizare={preautorizare.statusFinalizare}
                setDiagnostice={setDiagnostice}
                setIsModified={setIsModified}
                refresh={refresh }
            />

            <PreauthorizationForms
                id={param.id}
                finalizare={preautorizare.statusFinalizare}
                setFormulare={setFormulare}
                setNrFisiere={setNrFisiere}
                investigatii={investigatii}
                refresh={refresh}
            />

            <PreauthorizationFiles
                id={param.id}
                finalizare={preautorizare.statusFinalizare}
                setFisiere={setFisiere}
                setIsModified={setIsModified}
                refresh={refresh}
                partener={preautorizare.id ? preautorizare.idPartener : partener}
            />

            <div className="pt30 pb20 clearfix">
                <div className="col50p">
                    <button className="btn" name="back" onClick={handleCancel}>Inchide</button>
                </div>

                <div className="col50p right">
                    {!preautorizare.statusFinalizare == 1 && (
                        <>
                            <button className="btn" name="save" onClick={ handleSave}>Salveaza</button>
                            <button className="btn" name="finalizeaza" onClick={handleCompletion}>Finalizeaza</button>
                        </>
                    )}
                </div>
            </div>
        </>
    );
};

